module.exports = __webpack_public_path__ + "static/media/illustration.62e54028.png";